import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Field } from "@/components/Field";
import { http, errMsg } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const close = (o) => {
    if (!o) { setF(EMPTY); setError(""); }
    onOpenChange(o);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return setError("New passwords don't match");
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed. Other devices have been signed out.");
      close(false);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="change-password-dialog" style={{ background: "var(--surface)" }}>
        <DialogTitle className="font-display text-xl">Change password</DialogTitle>
        <DialogDescription style={{ color: "var(--ink-3)" }}>At least 8 characters. You'll stay signed in here; other devices will be signed out.</DialogDescription>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Current password" testid="change-current-password-input" type="password" required value={f.current} onChange={set("current")} autoComplete="current-password" />
          <Field label="New password" testid="change-new-password-input" type="password" required minLength={8} value={f.next} onChange={set("next")} autoComplete="new-password" />
          <Field label="Confirm new password" testid="change-confirm-password-input" type="password" required minLength={8} value={f.confirm} onChange={set("confirm")} autoComplete="new-password" />
          {error && <p data-testid="change-password-error" className="text-sm" style={{ color: "var(--alert)" }}>{error}</p>}
          <button data-testid="change-password-submit-button" disabled={busy} className="btn-primary w-full h-11 rounded-full font-semibold flex items-center justify-center gap-2">
            {busy && <Loader2 size={16} className="animate-spin" />} Update password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
